import CoverSection from "../Home/CoverSection/CoverSection";
import StudentsCards from "../Home/StudentsCards/StudentsCards";
import WhatItIsComponent from "../Home/WhatItIsComponent/WhatItIsComponent";
import VideoWrapper from "../Home/VideoWrapper/VideoWrapper";
import HowToCreateAccount from "../Home/HowToCreateAccount/HowToCreateAccount";
import RegisterNow from "../Home/RegisterNow/RegisterNow";

const YoungTalents = () => {
  return (
    <>
      <CoverSection />
      <StudentsCards />
      <WhatItIsComponent />
      <VideoWrapper />
      <HowToCreateAccount />
      <RegisterNow />
    </>
  );
};

export default YoungTalents;
